import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo } from "react";
import { seededShuffle } from "../utils/seededShuffle.js";
/**
 * Renders `items` in a deterministic pseudo-random slot order derived from `sessionId`.
 */ const RandomOrder = ({ items, enabled, sessionId, slotOrder })=>{
    const shuffledSlotOrder = useMemo(()=>seededShuffle(slotOrder, sessionId), [
        sessionId,
        slotOrder
    ]);
    const ordered = enabled ? [
        ...items
    ].sort((a, b)=>shuffledSlotOrder.indexOf(a.slot) - shuffledSlotOrder.indexOf(b.slot)) : items;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: ordered.map(({ slot, node })=>/*#__PURE__*/ _jsx(Fragment, {
                children: node
            }, slot))
    });
};
export { RandomOrder };
